export enum CloseReason {
    CustomerClosed = "CustomerClosed",
    RepClosed = "RepClosed",
    Cleared = "Cleared",
}
